export var ListLpFeesCategory;
(function (ListLpFeesCategory) {
    ListLpFeesCategory["DueUnapprovedFees"] = "dueUnapprovedFees";
    ListLpFeesCategory["FutureUnapprovedFees"] = "futureUnapprovedFees";
    ListLpFeesCategory["ApprovedFees"] = "approvedFees";
})(ListLpFeesCategory || (ListLpFeesCategory = {}));
//# sourceMappingURL=index.js.map